import { Component, Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonService } from '../services/common.service';
import { DialogService } from '../services/dialog.service';
import { ChangePageComponent } from '../dialogs/change-page/change-page.component';
import { ConfirmationChangePageModel } from '../model/http/commons.model';

@Injectable({
  providedIn: 'root'
})
export class ChangesConfirmationGuard implements CanDeactivate<Component> {
  constructor(private commonService: CommonService, private dialogService: DialogService) {
  }

  canDeactivate(
    component: Component,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.commonService.getHasChanges() && nextState?.url.includes('/search')) {
      return this.openConfirmationDialog();
    }
    return true;
  }

  openConfirmationDialog(): Observable<boolean> {
    const dataObject = new ConfirmationChangePageModel();
    dataObject.title = '¡Aviso!';
    dataObject.message = 'Se perderán los cambios. ¿Deseas salir sin guardar?';
    dataObject.closeTrueButton = 'Salir';
    dataObject.closeFalseButton = 'Regresar';
    const dialogRef = this.dialogService.displayDialog(ChangePageComponent, {
      data: dataObject
    });

    return dialogRef.afterClosed();
  }
}
